module.exports = __webpack_public_path__ + "img/icon-favourite.957c3636.svg";